const BasicAuth = ( username, password ) => {
 return {
   toString: ( ) => {
    const encodedAuth = Buffer.from(`${username}:${password}`,'utf8').toString('base64');
    return `Basic ${encodedAuth}`
   }
 }   
};

export default BasicAuth;


// WEBPACK FOOTER //
// ./src/api/BasicAuth.js